/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // -----------------------------------------------------------------------
  // Village Membership auto-add
  //
  // When a product tagged VILLAGE_CONFIG.triggerTag is in the cart, this
  // automatically adds The Village Membership (with its Appstle selling
  // plan) alongside it, so the offer is visible and removable in the cart -
  // never a silent/forced enrollment. If the customer removes it, it will
  // not be re-added again during the same browser tab session.
  //
  // Only the config below should need to change if the trigger tag,
  // membership variant, or selling plan ever change.
  // -----------------------------------------------------------------------
  var VILLAGE_CONFIG = {
    triggerTag: 'village-offer',
    membershipHandle: 'village',
    membershipVariantId: 62824572944543,
    // "Access live support" - 100% off from first order. Only ever applied
    // by this automation, never selectable directly on the product page
    // (kept hidden from the storefront widget), so it can't be obtained
    // without a qualifying trigger product in the cart.
    trialSellingPlanId: 3928293535,
    // "Monthly Subscription" - no discount. Used both for standalone
    // purchases (the product page default) and as the plan this
    // automation swaps a trial line back to if the trigger product is
    // removed.
    standardSellingPlanId: 3929014431,
    // sessionStorage keys - scoped to the browser tab session, cleared
    // automatically when the tab/session ends.
    wasInCartKey: 'villageMembershipWasInCart',
    dismissedKey: 'villageMembershipDismissed'
  };

  // handle -> Promise<string[]> tag cache, so we only fetch each product's
  // tags once per page even if the cart is re-evaluated many times.
  var productTagCache = {};

  function getProductTags(handle) {
    if (!productTagCache[handle]) {
      productTagCache[handle] = fetch('/products/' + handle + '.js')
        .then(function(response) { return response.json(); })
        .then(function(product) { return product.tags || []; })
        .catch(function() {
          // Graceful degradation: if the lookup fails, treat as "no tags"
          // rather than throwing - the cart itself is unaffected.
          return [];
        });
    }
    return productTagCache[handle];
  }

  function getCart() {
    return fetch('/cart.js').then(function(response) { return response.json(); });
  }

  // Fetched once and cached: the standard plan's price/name, so the
  // trial-to-paid swap can be painted on screen immediately (see
  // paintOptimisticSwap) instead of waiting on the swap's own network
  // round-trips. Warmed on page load below, well before any swap happens.
  var membershipPricingPromise = null;

  function getMembershipPricing() {
    if (!membershipPricingPromise) {
      // cache: 'no-store' - this endpoint has been observed serving a stale
      // CDN-cached price, and a wrong optimistic price (even briefly, even
      // self-correcting) isn't worth the risk of one extra fetch on load.
      membershipPricingPromise = fetch('/products/' + VILLAGE_CONFIG.membershipHandle + '.js', { cache: 'no-store' })
        .then(function(response) { return response.json(); })
        .then(function(product) {
          var variant = product.variants[0];
          var allocation = (variant.selling_plan_allocations || []).filter(function(a) {
            return a.selling_plan_id === VILLAGE_CONFIG.standardSellingPlanId;
          })[0];
          var group = (product.selling_plan_groups || [])[0];
          var plan = group && group.selling_plans.filter(function(p) {
            return p.id === VILLAGE_CONFIG.standardSellingPlanId;
          })[0];

          return {
            priceCents: allocation ? allocation.price : null,
            planName: plan ? plan.name : null
          };
        })
        .catch(function() {
          // Graceful degradation: no cached price just means the optimistic
          // paint is skipped for this session - the actual swap is unaffected.
          return { priceCents: null, planName: null };
        });
    }
    return membershipPricingPromise;
  }

  function formatMoney(cents) {
    if (window.theme && typeof window.theme.formatMoney === 'function' && window.theme.moneyFormat) {
      return window.theme.formatMoney(cents, window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // Paints the membership cart line as already on the paid plan before the
  // actual swap (removeLine + addMembership) has resolved, so the customer
  // sees the change instantly rather than after a network round-trip. Purely
  // visual - refreshThemeCart() overwrites this with the authoritative
  // server-rendered line once the real swap completes (or reconciles it if
  // the swap fails).
  function paintOptimisticSwap(membershipLine, pricing) {
    if (pricing.priceCents == null) return;

    var lineEl = document.querySelector('[data-item="' + membershipLine.key + '"]');
    if (!lineEl) return;

    var quantity = membershipLine.quantity || 1;
    var unitPriceEl = lineEl.querySelector('.cart__price');
    var totalPriceEl = lineEl.querySelector('.cart__item__price');
    var planLabelEl = lineEl.querySelector('.cart__item__selling-plan span');

    if (unitPriceEl) unitPriceEl.textContent = formatMoney(pricing.priceCents);
    if (totalPriceEl) totalPriceEl.textContent = formatMoney(pricing.priceCents * quantity);
    if (planLabelEl && pricing.planName) planLabelEl.textContent = pricing.planName;
  }

  function findMembershipLine(cart) {
    return cart.items.filter(function(item) {
      return item.variant_id === VILLAGE_CONFIG.membershipVariantId;
    })[0];
  }

  // The Ajax cart's selling_plan_allocation is null for a line with no
  // selling plan, so guard before reading the nested id.
  function currentSellingPlanId(item) {
    return item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id;
  }

  // Resolves true/false for whether any line item in the cart is tagged
  // with the trigger tag. Looks up tags per unique product handle so a
  // cart with several lines of the same product only does one fetch.
  function cartHasTriggerProduct(cart) {
    var handles = cart.items
      .map(function(item) { return item.handle; })
      .filter(function(handle, index, all) { return handle && all.indexOf(handle) === index; });

    return Promise.all(handles.map(getProductTags)).then(function(tagLists) {
      return tagLists.some(function(tags) {
        return tags.indexOf(VILLAGE_CONFIG.triggerTag) !== -1;
      });
    });
  }

  function addMembership(sellingPlanId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: VILLAGE_CONFIG.membershipVariantId,
          quantity: 1,
          selling_plan: sellingPlanId
        }]
      })
    }).then(function(response) {
      if (!response.ok) {
        throw new Error('Village membership add-to-cart failed with status ' + response.status);
      }
      return response.json();
    });
  }

  // A selling plan change isn't an in-place edit - variant + selling plan
  // combination is what makes a cart line's key unique - so swapping plans
  // means dropping the old line (by its key) and adding a fresh one.
  function removeLine(item) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 })
    }).then(function(response) {
      if (!response.ok) {
        throw new Error('Village membership line removal failed with status ' + response.status);
      }
      return response.json();
    });
  }

  // Re-renders the cart drawer/page using the theme's own refresh method,
  // so the newly-added line appears without a full page reload. Degrades
  // gracefully (no-op) if the <cart-items> element isn't on the page.
  function refreshThemeCart() {
    var cartItemsEl = document.querySelector('cart-items');
    if (cartItemsEl && typeof cartItemsEl.getCart === 'function') {
      cartItemsEl.getCart();
    }
  }

  // Guards against overlapping evaluations firing from rapid-fire cart
  // events (e.g. quantity stepper double-clicks).
  var isProcessing = false;

  function evaluateCart() {
    if (isProcessing) return;
    isProcessing = true;

    getCart()
      .then(function(cart) {
        var membershipLine = findMembershipLine(cart);
        var hasMembership = !!membershipLine;

        return cartHasTriggerProduct(cart).then(function(hasTrigger) {
          var wasInCart = sessionStorage.getItem(VILLAGE_CONFIG.wasInCartKey) === 'true';

          if (wasInCart && !hasMembership && hasTrigger) {
            // The membership was here before and now it isn't, while the
            // trigger product still is - the customer removed it on
            // purpose. Respect that for the rest of this tab session.
            sessionStorage.setItem(VILLAGE_CONFIG.dismissedKey, 'true');
            sessionStorage.setItem(VILLAGE_CONFIG.wasInCartKey, 'false');
            return;
          }

          var dismissed = sessionStorage.getItem(VILLAGE_CONFIG.dismissedKey) === 'true';

          if (hasTrigger && !hasMembership && !dismissed) {
            return addMembership(VILLAGE_CONFIG.trialSellingPlanId).then(function() {
              sessionStorage.setItem(VILLAGE_CONFIG.wasInCartKey, 'true');
              refreshThemeCart();
            });
          }

          if (hasMembership) {
            sessionStorage.setItem(VILLAGE_CONFIG.wasInCartKey, 'true');

            // Only this automation ever grants the trial plan, so if it's
            // on the cart without a qualifying trigger product present -
            // most commonly because the trigger was just removed - revoke
            // it by swapping the line back to the standard (no-discount)
            // plan. A membership added standalone from the product page
            // is unaffected: it's already on the standard plan, so this
            // is a no-op for that case.
            if (!hasTrigger && currentSellingPlanId(membershipLine) === VILLAGE_CONFIG.trialSellingPlanId) {
              // Paint the swap immediately - doesn't block the actual swap
              // below, and the pricing promise is normally already resolved
              // (warmed on page load) so this paints synchronously in practice.
              getMembershipPricing().then(function(pricing) {
                paintOptimisticSwap(membershipLine, pricing);
              });

              // Sequential, not parallel: Shopify's cart Ajax endpoints
              // aren't guaranteed atomic/ordered for concurrent mutations
              // on the same session. Firing removeLine and addMembership
              // together was tried and reliably raced in testing - the
              // remove silently didn't take effect, leaving both the trial
              // and standard lines in the cart at once. Not worth the
              // saved round-trip.
              return removeLine(membershipLine)
                .then(function() { return addMembership(VILLAGE_CONFIG.standardSellingPlanId); })
                .then(function() {
                  refreshThemeCart();
                })
                .catch(function(error) {
                  // The optimistic paint above may now be showing the paid
                  // price even though the swap didn't actually complete -
                  // resync with the server's real cart state rather than
                  // leaving a misleading price on screen.
                  refreshThemeCart();
                  throw error;
                });
            }
          }
        });
      })
      .catch(function(error) {
        // Graceful degradation: log and stop. Never let a failure here
        // (Appstle plan missing, network error, etc.) affect the
        // customer's own cart or checkout.
        console.warn('[village-auto-add]', error);
      })
      .finally(function() {
        isProcessing = false;
      });
  }

  // Re-evaluate after every cart mutation the theme's own AJAX cart makes.
  document.addEventListener('theme:cart:change', evaluateCart);

  // Also evaluate once on load, to catch a customer landing on the cart
  // page directly with the trigger product already in cart from an
  // earlier visit/session.
  evaluateCart();

  // Warm the pricing cache on load so it's already resolved by the time a
  // customer actually removes the trigger product later in the session.
  getMembershipPricing();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

(function () {
  // -----------------------------------------------------------------------
  // Kaching Bundles checkbox-upsell guide links
  //
  // Kaching's native "checkbox upsells" widget (the Peaceful Nights /
  // Toddler Sleep Course bundle-and-save rows) renders each companion
  // guide's name as plain text with no way to view the guide's own product
  // page - nothing in the widget's markup exposes the guide's handle/URL.
  //
  // Per Louise's UAT feedback (matching the Fast Bundle reference pattern),
  // the guide's name itself stays plain, unlinked text - only a small
  // external-link icon placed after the name is the actual click target,
  // so an accidental tap on the name can't navigate a customer away from
  // checkout. The icon opens the guide's page in a new tab and stops the
  // click from also toggling the row's checkbox.
  //
  // Add an entry to GUIDE_LINKS here if another guide is ever added to a
  // bundle widget - matched by the exact visible title text.
  // -----------------------------------------------------------------------
  var GUIDE_LINKS = {
    'Nap So Simple': '/products/nap-so-simple',
    'Weaning Gently': '/products/weaning-gently'
  };

  var EXTERNAL_LINK_ICON = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>';

  function addGuideLinks() {
    document.querySelectorAll('.kaching-bundles__checkbox-upsells__upsell .kaching-bundles__bar-title').forEach(function (titleEl) {
      var name = titleEl.textContent.trim();
      var url = GUIDE_LINKS[name];
      if (!url || titleEl.dataset.guideLinked) return;
      titleEl.dataset.guideLinked = 'true';

      var link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener';
      link.setAttribute('aria-label', 'View ' + name);
      link.style.display = 'inline-flex';
      link.style.verticalAlign = 'middle';
      link.style.marginLeft = '5px';
      link.style.color = 'rgba(0, 0, 0, 0.45)';
      link.innerHTML = EXTERNAL_LINK_ICON;
      // Kaching toggles the checkbox from a click handler on an ancestor of
      // this row - stop the click here so opening the guide's page doesn't
      // also flip the checkbox.
      link.addEventListener('click', function (e) { e.stopPropagation(); });

      titleEl.insertAdjacentElement('afterend', link);
    });
  }

  addGuideLinks();
  // Kaching injects this widget asynchronously after the page's initial
  // render, so keep watching for it rather than running addGuideLinks once.
  new MutationObserver(addGuideLinks).observe(document.body, { childList: true, subtree: true });
})();
